/* ZIZA: free tote popup (snippets/ziza-free-tote-popup.liquid).
   Telt kledingitems in de winkelwagen; bij 3+ zonder tote in de wagen
   verschijnt de popup (max 1x per sessie). Hoort bij de automatische
   Shopify-korting "Gratis tote bag bij 3 items".
   Verwijderen = deze file + de snippet + de render-regel in layout/theme.liquid. */
(function () {
  var SESSION_KEY = 'ziza-tote-popup-shown';

  var overlay = document.getElementById('ZizaFreeTotePopup');
  if (!overlay) return;
  if (window.Shopify && window.Shopify.designMode) return;

  /* Einddatum-guard voor gecachte pagina's; de snippet rendert na dit
     moment sowieso niet meer (promo_ends_at in de liquid). */
  var endsEpoch = parseInt(overlay.dataset.ends, 10);
  if (endsEpoch && Date.now() / 1000 >= endsEpoch) return;

  var minItems = parseInt(overlay.dataset.min, 10) || 3;
  var countTypes = (overlay.dataset.countTypes || '').split(',');
  var toteHandles = (overlay.dataset.toteHandles || '').split(',');

  function shownThisSession() {
    try { return sessionStorage.getItem(SESSION_KEY) === '1'; } catch (e) { return false; }
  }
  function markShown() {
    try { sessionStorage.setItem(SESSION_KEY, '1'); } catch (e) {}
  }

  var modal = overlay.querySelector('.ziza-tote-modal');
  var errorEl = overlay.querySelector('.ziza-tote-error');
  var opened = false;
  var lastFocus = null;

  function open() {
    if (opened || shownThisSession()) return;
    /* Niet over de signup-popup heen; probeer het zo weer. */
    var other = document.querySelector('.ziza-popup-overlay.is-open');
    if (other) {
      window.setTimeout(open, 8000);
      return;
    }
    opened = true;
    markShown();
    lastFocus = document.activeElement;
    overlay.hidden = false;
    overlay.classList.add('is-open');
    document.addEventListener('keydown', onKeydown);
  }

  function close() {
    overlay.classList.remove('is-open');
    overlay.hidden = true;
    document.removeEventListener('keydown', onKeydown);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKeydown(event) {
    if (event.key === 'Escape') close();
    if (event.key === 'Tab') {
      var focusables = modal.querySelectorAll('button, [tabindex]:not([tabindex="-1"])');
      var visible = Array.prototype.filter.call(focusables, function (el) {
        return el.offsetParent !== null && !el.disabled;
      });
      if (!visible.length) return;
      var first = visible[0];
      var last = visible[visible.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }
  }

  overlay.querySelector('.ziza-tote-close').addEventListener('click', close);
  overlay.querySelector('.ziza-tote-dismiss').addEventListener('click', close);
  overlay.addEventListener('click', function (event) {
    if (event.target === overlay) close();
  });

  /* Tote kiezen: toevoegen aan de wagen en door naar /cart, waar de
     automatische korting hem op gratis zet. */
  Array.prototype.forEach.call(overlay.querySelectorAll('.ziza-tote-option'), function (btn) {
    btn.addEventListener('click', function () {
      errorEl.style.display = 'none';
      Array.prototype.forEach.call(overlay.querySelectorAll('.ziza-tote-option'), function (b) {
        b.disabled = true;
      });
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'content-type': 'application/json' },
        body: JSON.stringify({ id: parseInt(btn.dataset.variantId, 10), quantity: 1 })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('add failed');
          window.location.href = '/cart';
        })
        .catch(function () {
          errorEl.style.display = 'block';
          Array.prototype.forEach.call(overlay.querySelectorAll('.ziza-tote-option'), function (b) {
            b.disabled = false;
          });
        });
    });
  });

  /* Cart checken: kledingitems tellen (zelfde afbakening als de korting),
     tote bags en caps tellen niet mee. Al een tote in de wagen = niet tonen. */
  var checking = false;
  function check() {
    if (opened || shownThisSession() || checking) return;
    checking = true;
    fetch('/cart.js', { headers: { accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        checking = false;
        if (!cart || !cart.items) return;
        var qualifying = 0;
        var hasTote = false;
        cart.items.forEach(function (item) {
          if (toteHandles.indexOf(item.handle) !== -1) hasTote = true;
          if (countTypes.indexOf(item.product_type) !== -1) qualifying += item.quantity;
        });
        if (qualifying >= minItems && !hasTote) open();
      })
      .catch(function () { checking = false; });
  }

  /* Her-checken na elke cart-wijziging: fetch naar /cart/add|change|update
     onderscheppen (Dawn gebruikt fetch voor alle cart-calls). */
  var origFetch = window.fetch;
  window.fetch = function () {
    var url = typeof arguments[0] === 'string' ? arguments[0] : (arguments[0] && arguments[0].url) || '';
    var result = origFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update)/.test(url)) {
      result.then(function () { window.setTimeout(check, 400); }).catch(function () {});
    }
    return result;
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', check);
  } else {
    check();
  }
  /* Ook bij terugnavigatie uit de bfcache (Safari/iOS). */
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) check();
  });
})();
